module.exports = __webpack_public_path__ + "img/unchecked.2d7bff92.svg";